declare global {
  interface RouterMeta {
    title: string;
  }
  interface Router {
    path: string;
    name: string;
    icon?: string;
    permission?: string;
    meta?: RouterMeta;
    component: any;
    children?: Array<Router>;
  }
  interface System {
    import(request: string): Promise<any>;
  }
  var System: System;
}
import login from '../views/login.vue';
import main from '../views/main.vue';
import flightReservationMonitor from '../views/pages/flight/flightReservationMonitor.vue';
import flightWizard from '../views/pages/flight/flightWizard.vue';
import flightChange from '../views/pages/flight/flightChange.vue';
import flightPassengerList from '../views/pages/flight/flightPassengerList.vue';
import flightOrderChange from '../views/pages/flight/flightOrderChange.vue';

export const loginRouter: Router = {
  path: '/',
  name: 'login',
  meta: {
    title: 'LogIn',
  },
  component: () => import('../views/login.vue'),
};

export const otherRouters: Router = {
  path: '/main',
  name: 'main',
  permission: '',
  meta: { title: 'ManageMenu' },
  component: main,
  children: [
    {
      path: 'home',
      meta: { title: 'HomePage' },
      name: 'home',
      component: () => import('../views/pages/home.vue'),
    },
  ],
};

export const appRouters: Array<Router> = [
  {
    path: '/pages/flight',
    name: 'flight',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [

      {
        path: 'flightReservationMonitor',
        meta: { title: 'Flight Reservation Monitor' },
        name: 'flightReservationMonitor',
        component: () =>
          import('../views/pages/flight/flightReservationMonitor.vue'),
      },
      {
        path: 'flightWizard',
        meta: { title: 'Flight Wizard' },
        name: 'flightWizard',
        component: () => import('../views/pages/flight/flightWizard.vue'),
      },
      {
        path: 'flightChange',
        meta: { title: 'Flight Change' },
        name: 'flightChange',
        component: () => import('../views/pages/flight/flightChange.vue'),
      },
      {
        path: 'flightPassengerList',
        meta: { title: 'Flight Passenger List' },
        name: 'flightPassengerList',
        component: () =>
          import('../views/pages/flight/flightPassengerList.vue'),
      },
      {
        path: 'flightOrderChange',
        meta: { title: 'Flight Order Change' },
        name: 'flightOrderChange',
        component: () => import('../views/pages/flight/flightOrderChange.vue'),
      },
    ],
  },
];

export const routers = [loginRouter, ...appRouters, otherRouters];
